import { Nl2Br } from '@findy-code/yuffie/shared/nl2br';
import { Heading } from '@findy-code/yuffie/ui/heading';
import { Stack } from '@findy-code/yuffie/ui/stack';

import { useExpandableItems } from '../../../common';
import styles from './company-detail-products.component.module.scss';
import { SectionLayout } from './section-layout.component';

type ProductType = {
  id: number;
  name: string;
  image?: {
    filename: string;
    url: string;
  } | null;
  explanation: string;
  url: string;
};

type Props = {
  products: ProductType[];
};

const ProductItem = ({ product }: { product: ProductType }) => {
  return (
    <Stack
      align="center"
      direction={{ base: 'column', md: 'row' }}
      spacing={{ base: 'xxs', md: 'm' }}
    >
      {product.image?.url && (
        <div className={styles.productThumb}>
          <img alt={product.name} src={product.image.url} />
        </div>
      )}
      <div className={styles.productContent}>
        <Heading as="h3" style={{ fontSize: '20px', color: '#444' }}>
          {product.name}
        </Heading>
        <p className={styles.productDescription}>
          <Nl2Br text={product.explanation} />
        </p>
        <a
          className={styles.productLink}
          href={product.url}
          rel="noopener"
          target="_blank"
        >
          {product.url}
        </a>
      </div>
    </Stack>
  );
};

export const CompanyDetailProducts = ({ products }: Props) => {
  const { displayItems, ExpandButton } = useExpandableItems(
    products,
    2,
    'プロダクトをもっとみる'
  );
  return (
    <SectionLayout heading={{ title: 'プロダクト' }} id="product">
      <Stack
        className={styles.productBlock}
        style={{ gap: 'var(--block-gap)' }}
      >
        {displayItems.map((product) => (
          <ProductItem key={product.id} product={product} />
        ))}
      </Stack>
      <ExpandButton />
    </SectionLayout>
  );
};
